<template>
  <div class="animated fadeIn" id="dashboard">
    <div id="Dashboard">
      <div class="text">
        <h1>{{ $t("dashboard.title") }}</h1>
        <p>{{ $t("dashboard.subtitle") }}</p>
        <p>{{ $t("dashboard.subtitle2") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dashboard"
};
</script>
<style >
#dashboard {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 2rem;
  height: 60vh;
  align-items: center;
  justify-content: center;
  text-align: center;
}
#dashboard h1 {
  font-size: 3rem;
}
#dashboard p {
  font-size: 1.2rem;
}
#dashboard p + p {
  margin-top: -1.1rem;
}
#dashboard .text {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
</style>